import React from "react";

const MonthHeader = ({ yearMonth, formatMonth, navigate }) => {
  const styles = {
    header: {
      marginBottom: "2rem",
    },
    titleRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      marginBottom: "1rem",
    },
    title: {
      fontSize: "1.875rem",
      fontWeight: "700",
      color: "#001272",
      margin: "0 0 0.5rem 0",
    },
    subtitle: {
      color: "#001272",
      opacity: "0.8",
      fontSize: "1rem",
      margin: "0",
    },
    backButton: {
      backgroundColor: "transparent",
      color: "#001272",
      border: "1px solid #001272",
      borderRadius: "0.375rem",
      padding: "0.5rem 1rem",
      fontWeight: "500",
      cursor: "pointer",
      transition: "all 0.2s",
    },
    backButtonHover: {
      backgroundColor: "#001272",
      color: "white",
    },
  };

  return (
    <div style={styles.header}>
      <div style={styles.titleRow} data-responsive-title-row>
        <div>
          <h1 style={styles.title}>{formatMonth(yearMonth)}</h1>
          <p style={styles.subtitle}>
            Manage sync operations and generate payroll for this month
          </p>
        </div>
        <button
          style={styles.backButton}
          data-responsive-back-button
          onClick={() => navigate("/")}
          onMouseEnter={(e) => {
            Object.assign(e.currentTarget.style, styles.backButtonHover);
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "transparent";
            e.currentTarget.style.color = "#001272";
          }}
        >
          ← Back to Dashboard
        </button>
      </div>
    </div>
  );
};

export default MonthHeader;
